export const translations = {
  tr: {
    nav: {
      home: "Anasayfa",
      services: "Hizmetler",
      about: "Hakkımızda",
      blog: "Blog",
      contact: "İletişim",
      cta: "Görüşme Talep Et",
    },
    home: {
      overline: "ROTAM Tax & Financial Advisory",
      heroTitle: "Kurumsal vizyon, güvenilir finansal danışmanlık.",
      heroSubtitle:
        "KOBİ'ler, aile şirketleri ve yabancı sermayeli yatırımcılar için bütünleşik muhasebe, vergi ve finansal danışmanlık.",
      heroCta: "Ücretsiz Ön Görüşme",
      heroSecondary: "Hizmetlerimizi Keşfedin",
      statsExp: "Yıllık Deneyim",
      statsClient: "Aktif Müşteri",
      statsRetention: "Müşteri Memnuniyeti",
      statsCountries: "Ülke Çapında Mükellef",
      servicesOverline: "Hizmetlerimiz",
      servicesTitle: "Finansal süreçlerinizin tamamı, tek bir disiplin altında.",
      servicesDesc:
        "Mevzuata uyumdan stratejik karar desteğine kadar; işletmenizin her aşamasında yanınızdayız.",
      whyOverline: "Neden ROTAM",
      whyTitle: "Sadece raporlamıyoruz; rota çiziyoruz.",
      whyDesc:
        "Yirmi yılı aşkın saha tecrübemiz, sertifikalı uzman kadromuz ve dijital altyapımızla her ölçekten şirkete uçtan uca finansal görünürlük sağlıyoruz.",
      why1Title: "Sertifikalı Uzman Ekibi",
      why1Desc: "Mali müşavirler, uzman danışmanlar ve SGK ile İş Kanunu uzmanlarıyla tek bir çatı altında çalışın.",
      why2Title: "Çok Dilli Hizmet",
      why2Desc: "Yabancı sermayeli şirketlere Türkçe ve İngilizce raporlama ile yatırım danışmanlığı.",
      why3Title: "Dijital İş Akışları",
      why3Desc: "e-Defter, e-Fatura, bulut tabanlı muhasebe ve gerçek zamanlı dashboard çözümleri.",
      why4Title: "Şeffaf Ücretlendirme",
      why4Desc: "Sabit aylık paketler, sürpriz fatura yok. Önceden tanımlı kapsam ve hedefler.",
      industriesOverline: "Sektörler",
      industriesTitle: "Geniş bir mükellef portföyüne hizmet veriyoruz.",
      industries: [
        "Üretim & İhracat",
        "Bilişim & Yazılım",
        "Perakende & e-Ticaret",
        "İnşaat & Gayrimenkul",
        "Sağlık & Eczacılık",
        "Lojistik & Taşımacılık",
        "Turizm & Otelcilik",
        "Tarım & Gıda",
      ],
      ctaTitle: "Şirketinizin finansal rotasını birlikte çizelim.",
      ctaDesc:
        "Mevcut yapınızı ücretsiz analiz edelim, riskleri tespit edip büyüme fırsatlarını ortaya çıkaralım.",
      ctaButton: "Hemen İletişime Geçin",
      testimonialsOverline: "Müşterilerimiz",
      testimonialsTitle: "Bizimle çalışanlar ne söylüyor?",
    },
    services: {
      overline: "Hizmetlerimiz",
      title: "Uçtan uca finansal & vergisel çözümler",
      description:
        "Kuruluş aşamasından stratejik büyümeye kadar şirketinizin tüm finansal süreçlerini biz yönetelim.",
      items: [
        {
          key: "muhasebe",
          title: "Muhasebe Hizmetleri",
          desc: "Yasal defter tutma, dönemsel raporlama, bilanço ve gelir tablosu hazırlanması, BA-BS uyum kontrolleri.",
        },
        {
          key: "vergi",
          title: "Vergi Danışmanlığı",
          desc: "Kurumlar vergisi, gelir vergisi, stopaj ve KDV planlaması; vergi incelemelerinde temsil ve uzlaşma süreci yönetimi.",
        },
        {
          key: "sgk",
          title: "SGK İşlemleri",
          desc: "İşe giriş-çıkış bildirgeleri, SGK teşvik takibi, denetim ve teftiş süreçlerinde işveren temsiliyeti.",
        },
        {
          key: "bordro",
          title: "Bordro Yönetimi",
          desc: "Aylık bordro hazırlığı, kıdem-ihbar hesabı, AGİ uygulamaları, yabancı personel çalışma izni süreçleri.",
        },
        {
          key: "rapor",
          title: "Finansal Raporlama",
          desc: "IFRS ve TFRS uyumlu finansal tablolar, yönetim raporları, KPI dashboardları ve yatırımcı sunumları.",
        },
        {
          key: "butce",
          title: "Bütçe Yönetimi",
          desc: "Yıllık bütçe planlaması, nakit akış projeksiyonları, sapma analizleri ve maliyet kontrol sistemleri.",
        },
        {
          key: "kdv",
          title: "KDV İadesi",
          desc: "İhracat, indirimli oran ve yatırım teşvikli KDV iade dosyalarının hazırlanması ve sonuçlandırılması.",
        },
        {
          key: "edefter",
          title: "e-Defter & e-Fatura",
          desc: "GİB entegrasyonu, e-Defter beratlama, e-Arşiv, e-İrsaliye ve e-SMM danışmanlığı.",
        },
      ],
    },
    about: {
      overline: "Hakkımızda",
      title: "Rotanızı belirleyen, rakamların ardındaki uzman ekip.",
      lead:
        "ROTAM, kurulduğu günden bu yana sayıların ardındaki hikâyeyi anlamlandırarak; KOBİ'ler, aile şirketleri ve uluslararası yatırımcılar için sürdürülebilir büyümenin finansal mimarisini inşa ediyor.",
      missionTitle: "Misyonumuz",
      missionDesc:
        "Müşterilerimize sadece mevzuat uyumu değil; stratejik karar süreçlerinde güvenilir bir danışman olarak değer katmak.",
      visionTitle: "Vizyonumuz",
      visionDesc:
        "Türkiye'nin önde gelen, dijital yetkinlikleri yüksek, uluslararası standartta finansal danışmanlık ofisi olmak.",
      valuesTitle: "Değerlerimiz",
      values: [
        { title: "Güven", desc: "Sır saklama ve etik değerler her zaman önceliğimizdir." },
        { title: "Şeffaflık", desc: "Açık iletişim ve net raporlama ile çalışırız." },
        { title: "Uzmanlık", desc: "Sürekli eğitim ve sertifikasyon ile bilgi taze kalır." },
        { title: "Yenilikçilik", desc: "Dijital araçlar ve veri analitiği iş yapış biçimimizdir." },
      ],
      teamTitle: "Liderlik Ekibimiz",
      team: [
        { name: "Meryem Güldaş Döne", role: "Kurucu Ortak · Serbest Muhasebeci Mali Müşavir", bio: "Yıllara dayanan tecrübesiyle ROTAM'ın kurucu ortağı.", photo: "https://customer-assets.emergentagent.com/job_tax-consulting-1/artifacts/cfjcaolk_PHOTO-2026-01-18-21-42-52meryem.jpg" },
        { name: "Abbas Döne", role: "Serbest Muhasebeci Mali Müşavir", bio: "Vergi ve finansal raporlama alanında uzman.", photo: "https://customer-assets.emergentagent.com/job_tax-consulting-1/artifacts/dpmurwfq_PHOTO-2026-01-18-21-45-52abbas.jpg" },
        { name: "Cansel Kocadağ", role: "Serbest Muhasebeci Mali Müşavir", bio: "SGK, bordro ve İş Kanunu mevzuatı uzmanı.", photo: "https://customer-assets.emergentagent.com/job_tax-consulting-1/artifacts/b6sqfrsu_WhatsApp%20Image%202026-06-06%20at%2023.43.45.jpeg" },
      ],
    },
    blog: {
      overline: "İçgörüler",
      title: "Güncel mevzuat ve finans gündemi",
      description:
        "Vergi, SGK, e-dönüşüm ve finansal yönetim alanlarında uzmanlarımızın hazırladığı içerikler.",
      readMore: "Devamını Oku",
      backToBlog: "Tüm Yazılar",
      minRead: "dk okuma",
      relatedTitle: "İlgili yazılar",
      notFound: "Aradığınız yazı bulunamadı.",
    },
    contact: {
      overline: "İletişim",
      title: "Size nasıl yardımcı olabiliriz?",
      description:
        "Formu doldurun, uzmanlarımız 24 saat içinde sizinle iletişime geçsin. Ön görüşme tamamen ücretsizdir.",
      name: "Ad Soyad",
      company: "Şirket",
      email: "E-posta",
      phone: "Telefon",
      service: "İlgilendiğiniz Hizmet",
      selectService: "Hizmet seçiniz",
      message: "Mesajınız",
      submit: "Mesajı Gönder",
      submitting: "Gönderiliyor...",
      success: "Talebiniz alındı. En kısa sürede sizinle iletişime geçeceğiz.",
      error: "Bir hata oluştu, lütfen tekrar deneyin.",
      officeTitle: "Ofisimiz",
      hoursTitle: "Çalışma Saatleri",
      hours: "Pzt – Cum  09:00 – 18:00",
      address: "Hürriyet Mh. Mahmutbey Cd. No:13 Bahçelievler / İstanbul",
      phoneNumber: "+90 532 158 18 06",
      emailAddress: "abbasdone@gmail.com",
    },
    footer: {
      tagline:
        "Sayıların ardındaki hikâyeyi okur, doğru rotayı sizinle birlikte belirleriz.",
      navTitle: "Bağlantılar",
      servicesTitle: "Hizmetler",
      contactTitle: "İletişim",
      rights: "Tüm hakları saklıdır.",
    },
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      about: "About",
      blog: "Insights",
      contact: "Contact",
      cta: "Book a Call",
    },
    home: {
      overline: "ROTAM Tax & Financial Advisory",
      heroTitle: "Corporate vision, trusted financial advisory.",
      heroSubtitle:
        "Integrated accounting, tax and financial advisory for SMEs, family businesses and foreign-capital investors operating in Türkiye.",
      heroCta: "Book a Free Consultation",
      heroSecondary: "Explore our Services",
      statsExp: "Years of Experience",
      statsClient: "Active Clients",
      statsRetention: "Client Retention",
      statsCountries: "Countries Served",
      servicesOverline: "Our Services",
      servicesTitle: "Your entire finance function, under one discipline.",
      servicesDesc:
        "From statutory compliance to strategic decision support — we are with you at every stage of your business.",
      whyOverline: "Why ROTAM",
      whyTitle: "We don't just report — we map your route.",
      whyDesc:
        "With more than two decades of field experience, a multidisciplinary expert team and a fully digital workflow, we deliver end-to-end financial visibility to companies of every scale.",
      why1Title: "Certified Expert Team",
      why1Desc: "Work with CPAs, expert advisors and specialists in social security & labor law — all under one roof.",
      why2Title: "Multilingual Service",
      why2Desc: "Bilingual reporting (TR/EN) and investment advisory for foreign-capital companies.",
      why3Title: "Digital Workflows",
      why3Desc: "e-Ledger, e-Invoice, cloud accounting and real-time dashboard solutions.",
      why4Title: "Transparent Pricing",
      why4Desc: "Fixed monthly packages, no surprise invoices. Clearly scoped engagements.",
      industriesOverline: "Industries",
      industriesTitle: "We serve a broad portfolio of taxpayers.",
      industries: [
        "Manufacturing & Export",
        "IT & Software",
        "Retail & e-Commerce",
        "Construction & Real Estate",
        "Healthcare & Pharma",
        "Logistics & Transport",
        "Tourism & Hospitality",
        "Agriculture & Food",
      ],
      ctaTitle: "Let's chart your company's financial route — together.",
      ctaDesc:
        "We'll review your current setup for free, identify risks and uncover growth opportunities.",
      ctaButton: "Get in Touch",
      testimonialsOverline: "Clients",
      testimonialsTitle: "What our clients say",
    },
    services: {
      overline: "Our Services",
      title: "End-to-end financial & tax solutions",
      description:
        "From incorporation to strategic growth, let us run your company's entire financial back office.",
      items: [
        {
          key: "muhasebe",
          title: "Accounting Services",
          desc: "Statutory bookkeeping, periodic reporting, balance sheet and P&L preparation, BA-BS reconciliations.",
        },
        {
          key: "vergi",
          title: "Tax Advisory",
          desc: "Corporate, income, withholding and VAT planning; representation in tax audits and reconciliation processes.",
        },
        {
          key: "sgk",
          title: "Social Security (SGK)",
          desc: "Employee declarations, incentive tracking, employer representation in SGK audits and inspections.",
        },
        {
          key: "bordro",
          title: "Payroll Management",
          desc: "Monthly payroll, severance and notice calculations, expat work-permit processes.",
        },
        {
          key: "rapor",
          title: "Financial Reporting",
          desc: "IFRS / TFRS compliant statements, management reports, KPI dashboards and investor decks.",
        },
        {
          key: "butce",
          title: "Budget Management",
          desc: "Annual budgeting, cash-flow projections, variance analysis and cost control systems.",
        },
        {
          key: "kdv",
          title: "VAT Refund",
          desc: "Preparation and follow-up of VAT refund files for exporters, reduced-rate and investment-incentive cases.",
        },
        {
          key: "edefter",
          title: "e-Ledger & e-Invoice",
          desc: "GİB integration, e-Ledger sealing, e-Archive, e-Waybill and e-SMM advisory.",
        },
      ],
    },
    about: {
      overline: "About Us",
      title: "The expert team behind the numbers that set your route.",
      lead:
        "Since day one, ROTAM has been decoding the story behind the numbers — building the financial architecture of sustainable growth for SMEs, family businesses and international investors.",
      missionTitle: "Our Mission",
      missionDesc:
        "To add value as a trusted advisor in strategic decisions, beyond mere statutory compliance.",
      visionTitle: "Our Vision",
      visionDesc:
        "To become Türkiye's leading, digitally advanced, internationally aligned financial advisory practice.",
      valuesTitle: "Our Values",
      values: [
        { title: "Trust", desc: "Confidentiality and ethics are always our top priority." },
        { title: "Transparency", desc: "We operate with open communication and clear reporting." },
        { title: "Expertise", desc: "Continuous training and certification keep our knowledge fresh." },
        { title: "Innovation", desc: "Digital tools and data analytics are how we do business." },
      ],
      teamTitle: "Leadership Team",
      team: [
        { name: "Meryem Güldaş Döne", role: "Founding Partner · Certified Public Accountant (SMMM)", bio: "Founding partner of ROTAM with extensive industry experience.", photo: "https://customer-assets.emergentagent.com/job_tax-consulting-1/artifacts/cfjcaolk_PHOTO-2026-01-18-21-42-52meryem.jpg" },
        { name: "Abbas Döne", role: "Certified Public Accountant (SMMM)", bio: "Specialist in tax and financial reporting.", photo: "https://customer-assets.emergentagent.com/job_tax-consulting-1/artifacts/dpmurwfq_PHOTO-2026-01-18-21-45-52abbas.jpg" },
        { name: "Cansel Kocadağ", role: "Certified Public Accountant (SMMM)", bio: "Expert in social security (SGK), payroll and labor law.", photo: "https://customer-assets.emergentagent.com/job_tax-consulting-1/artifacts/b6sqfrsu_WhatsApp%20Image%202026-06-06%20at%2023.43.45.jpeg" },
      ],
    },
    blog: {
      overline: "Insights",
      title: "Latest in regulation and finance",
      description:
        "Articles by our experts on tax, social security, e-transformation and financial management.",
      readMore: "Read more",
      backToBlog: "All articles",
      minRead: "min read",
      relatedTitle: "Related articles",
      notFound: "The article you are looking for was not found.",
    },
    contact: {
      overline: "Contact",
      title: "How can we help?",
      description:
        "Fill in the form and our experts will get back to you within 24 hours. The first consultation is always free.",
      name: "Full Name",
      company: "Company",
      email: "Email",
      phone: "Phone",
      service: "Service of Interest",
      selectService: "Select a service",
      message: "Your Message",
      submit: "Send Message",
      submitting: "Sending...",
      success: "Your request has been received. We'll be in touch shortly.",
      error: "Something went wrong. Please try again.",
      officeTitle: "Our Office",
      hoursTitle: "Working Hours",
      hours: "Mon – Fri  09:00 – 18:00",
      address: "Hürriyet Mh. Mahmutbey Cd. No:13 Bahçelievler / İstanbul",
      phoneNumber: "+90 532 158 18 06",
      emailAddress: "abbasdone@gmail.com",
    },
    footer: {
      tagline:
        "We read the story behind the numbers and chart the right route with you.",
      navTitle: "Links",
      servicesTitle: "Services",
      contactTitle: "Contact",
      rights: "All rights reserved.",
    },
  },
};

export const SERVICE_KEYS = [
  "muhasebe",
  "vergi",
  "sgk",
  "bordro",
  "rapor",
  "butce",
  "kdv",
  "edefter",
];
